import { isBrowser, getBrowserApiConfig } from './config';
import { env } from './env';
import { getServerStampedHeaders } from './server';
import { resolveTenantId } from './tenant';

const isAuthEndpoint = (url: string) =>
  url.includes('/auth') || url.includes('auth');

/**
 * Resolve base URL for the endpoint.
 * - Auth endpoints go to SuperTokens base
 * - Non-auth endpoints can be stamped by x-api-base, or derived from tenantId
 */
export const resolveBaseUrl = async (
  url: string,
  reqHeaders?: HeadersInit,
  optsTenantId?: string | null,
): Promise<string> => {
  const authEP = isAuthEndpoint(url);

  // browser prefers runtime config
  if (isBrowser()) {
    const cfg = getBrowserApiConfig();

    if (authEP) return cfg.superTokensApiUrl || env.superTokensApiUrl;

    if (!cfg.apiBaseUrl) {
      throw new Error(
        '[resolveBaseUrl] Missing browser apiBaseUrl (ApiRuntimeConfig not mounted?)',
      );
    }

    return cfg.apiBaseUrl || env.apiBaseUrl;
  }

  if (authEP) return env.superTokensApiUrl;

  const stamped = await getServerStampedHeaders();

  if (stamped.apiBase) return stamped.apiBase;

  const tenantId = await resolveTenantId({
    tenantId: optsTenantId ?? undefined,
    headers: reqHeaders,
  });

  if (tenantId) {
    const { apiBaseFor } = await import('@/lib/tenants');
    return apiBaseFor(tenantId);
  }

  return env.apiBaseUrl;
};
